// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_g6-3";
export var flatBottomCorners = "_g6-5";
export var productImage = "_g6-0";
export var quantityContainer = "_g6-2";
export var quantityHeader = "_g6-6";
export var tooltip = "_g6-1";
export var wrapAndEllipsesOverflow = "_g6-4";